import { Component, OnInit} from "@angular/core";
import { AuthService } from "@app/service/auth.service";
import { environment } from "@env";
import {

  NbMenuService,
  NbSidebarService,
  NbThemeService
} from "@nebular/theme";
import {  map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { NbDialogService } from "@nebular/theme";
import { OktaAuthService } from "@okta/okta-angular";
const issuer = environment.OKTA_ISSUER;
const redirectUri = `${window.location.origin}`;
import { Router } from "@angular/router";

@Component({
  selector: 'app-no-auth-header',
  templateUrl: './no-auth-header.component.html',
  styleUrls: ['./no-auth-header.component.scss'],

})
export class NoAuthHeaderComponent implements OnInit {
  public version = environment.version;
  currentTheme = "dark";
  private destroy$: Subject<void> = new Subject<void>();
  themes = [
    {
      value: "default",
      name: "Light"
    },
    {
      value: "dark",
      name: "Dark"
    },
    {
      value: "cosmic",
      name: "Cosmic"
    },
    {
      value: "corporate",
      name: "Corporate"
    }
  ];

 constructor(
      private themeService: NbThemeService,
      private nbMenuService: NbMenuService,
      private sidebarService: NbSidebarService,
      private dialogService: NbDialogService,
      public oktaAuth: OktaAuthService,
      private router: Router
  ) {}

  async ngOnInit() {
    /***
     * Place to change the application theme
     * **/

    this.changeTheme(this.themes[0].value);
    this.themeService
        .onThemeChange()
        .pipe(
            map(({ name }) => name),
            takeUntil(this.destroy$)
        )
        .subscribe(themeName => (this.currentTheme = themeName));
  }
  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }
  toggleSidebar() {
    this.sidebarService.toggle(true, 'left');
    return false;
  }



}
